module.exports = __webpack_public_path__ + "img/xm05-3115af.png";